import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, postFormDataRequest, postRequest, putRequest } from "../apiHelpers";
import {
  approveLegacyLifeBillRequestURL,
  approveLegacyLifeEntryURL,
  createLegacyLifeBillURL,
  createLegacyLifeEntryDraftURL,
  getLegacyLifeBillRequestByIdURL,
  getLegacyLifeBillRequestsURL,
  getLegacyLifeEntryByIdURL,
  getLegacyLifeEntryListURL,
  previewLegacyLifeBillURL,
  rejectLegacyLifeBillRequestURL,
  rejectLegacyLifeEntryURL,
  searchLegacyLifeContractURL,
  submitLegacyLifeEntryURL,
  updateLegacyLifeEntryDraftURL,
  uploadLegacyLifeEntryFileURL,
} from "../pathApi";

export const callGetLegacyLifeEntryList = createAsyncThunk(
  getLegacyLifeEntryListURL,
  async (params = {}) => getRequest({ url: getLegacyLifeEntryListURL, params })
);

export const callGetLegacyLifeEntryById = createAsyncThunk(
  `${getLegacyLifeEntryByIdURL}/detail`,
  async id => getRequest({ url: `${getLegacyLifeEntryByIdURL}/${id}` })
);

export const callCreateLegacyLifeEntryDraft = createAsyncThunk(
  createLegacyLifeEntryDraftURL,
  async data => postRequest({ url: createLegacyLifeEntryDraftURL, data })
);

export const callUpdateLegacyLifeEntryDraft = createAsyncThunk(
  `${updateLegacyLifeEntryDraftURL}/draft/update`,
  async ({ id, data }) => putRequest({ url: `${updateLegacyLifeEntryDraftURL}/${id}/draft`, data })
);

export const callSubmitLegacyLifeEntry = createAsyncThunk(
  `${submitLegacyLifeEntryURL}/submit`,
  async id => postRequest({ url: `${submitLegacyLifeEntryURL}/${id}/submit` })
);

export const callApproveLegacyLifeEntry = createAsyncThunk(
  `${approveLegacyLifeEntryURL}/approve`,
  async id => postRequest({ url: `${approveLegacyLifeEntryURL}/${id}/approve` })
);

export const callRejectLegacyLifeEntry = createAsyncThunk(
  `${rejectLegacyLifeEntryURL}/reject`,
  async ({ id, reason }) => postRequest({ url: `${rejectLegacyLifeEntryURL}/${id}/reject`, data: { reason } })
);

export const callUploadLegacyLifeEntryFiles = createAsyncThunk(
  uploadLegacyLifeEntryFileURL,
  async ({ contractNumber, files }) => {
    const formData = new FormData();
    files.forEach(file => formData.append("file", file));
    return postFormDataRequest({
      url: `${uploadLegacyLifeEntryFileURL}/${contractNumber || "draft"}`,
      formData,
    });
  }
);

export const callSearchLegacyLifeContract = createAsyncThunk(
  searchLegacyLifeContractURL,
  async params => getRequest({ url: searchLegacyLifeContractURL, params })
);

export const callPreviewLegacyLifeBill = createAsyncThunk(
  previewLegacyLifeBillURL,
  async data => postRequest({ url: previewLegacyLifeBillURL, data })
);

export const callCreateLegacyLifeBill = createAsyncThunk(
  createLegacyLifeBillURL,
  async data => postRequest({ url: createLegacyLifeBillURL, data })
);

export const callGetLegacyLifeBillRequests = createAsyncThunk(
  getLegacyLifeBillRequestsURL,
  async (params = {}) => getRequest({ url: getLegacyLifeBillRequestsURL, params })
);

export const callGetLegacyLifeBillRequestById = createAsyncThunk(
  `${getLegacyLifeBillRequestByIdURL}/detail`,
  async id => getRequest({ url: `${getLegacyLifeBillRequestByIdURL}/${id}` })
);

export const callApproveLegacyLifeBillRequest = createAsyncThunk(
  `${approveLegacyLifeBillRequestURL}/approve`,
  async id => postRequest({ url: `${approveLegacyLifeBillRequestURL}/${id}/approve` })
);

export const callRejectLegacyLifeBillRequest = createAsyncThunk(
  `${rejectLegacyLifeBillRequestURL}/reject`,
  async ({ id, reason }) => postRequest({ url: `${rejectLegacyLifeBillRequestURL}/${id}/reject`, data: { reason } })
);

export const callUpdateRejectedLegacyLifeBill = createAsyncThunk(
  `${createLegacyLifeBillURL}/rejected/update`,
  async ({ id, data }) => putRequest({ url: `${getLegacyLifeBillRequestByIdURL}/${id}`, data })
);
